/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import Menu from './Menu/index'
import React from 'react'
import ReportUserLastSeen from './ReportUserLastSeen/index'
import UpdateNotice from './UpdateNotice/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content1({
  children,
  viewPath = "/App/Account/Content"
  
}) {
  let isMedia = useIsMedia()
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<ReportUserLastSeen
  viewPath={`${viewPath}/ReportUserLastSeen`}
/>
<UpdateNotice
  viewPath={`${viewPath}/UpdateNotice`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral100,'--fd-2-Z1Yf8zk': isMedia.laptop ? "row" : "column"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--o-3-Z1Yf8zk': isMedia.laptop ? 2 : 1}}
 className={`views-block ${styles.Vertical1}`}
>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
<div
  data-testid="Content1.Vertical:2"
  data-view-path={viewPath}
 style={{'--o-3-Z1Yf8zk': isMedia.laptop ? 1 : 2}}
 className={`views-block ${styles.Vertical2}`}
>
<Menu
  viewPath={`${viewPath}/Menu`}
/>
</div>
</div>
{children}
</React.Fragment>)
}